/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Styles
import { baseStyle } from './style';

// Components
import Text, { TEXT_TYPES } from '../text';
import classNames from 'classnames';
import BackgroundImage from 'gatsby-background-image';

export interface TabsGroup {
  tabs: {
    tab: {
      tabContent: {
        descriptions: {
          descriptionContent: string;
        }[];
        title: string;
        backgroundImage: ImageType;
        mobileBackgroundImage: ImageType;
      };
      tabNameTitle: string;
    };
  }[];
  title: string;
  backgroundImage: ImageType;
}
export interface TabsContentProps {
  className?: string;
  tabsgroup: TabsGroup;
}

const TabsContent: FunctionComponent<TabsContentProps> = React.memo(
  ({ className, tabsgroup }) => {
    const [selectedTab, setSelectedTab] = React.useState<number>(0);
    const [selectedTabCaption, setSelectedTabCaption] = React.useState<string>(
      tabsgroup.tabs[0].tab.tabNameTitle,
    );
    const descriptionContent = (item: any) => (
      <Box sx={baseStyle.desCriptionTitleContainer}>
        <Text sx={baseStyle.descriptionTitle} type={TEXT_TYPES.SIDEBAR_H1}>
          {item.tab.tabNameTitle}
        </Text>
        {item.tab.tabContent.descriptions.map((description: any) => (
          <Box sx={baseStyle.tabDescriptionContentContainer}>
            <Text type={TEXT_TYPES.PULL_QUOTE}>
              <span
                sx={baseStyle.tabDescriptionSpan}
                dangerouslySetInnerHTML={{
                  __html: description.descriptionContent,
                }}
              />
            </Text>
          </Box>
        ))}
      </Box>
    );
    return (
      <Box
        sx={baseStyle.mainContainer}
        className={classNames('TabsContent', className)}
      >
        <BackgroundImage
          sx={baseStyle.mainBackgroundImage}
          fluid={tabsgroup.backgroundImage.localFile?.childImageSharp?.fluid}
        >
          <Flex sx={baseStyle.contentContainer}>
            <Box sx={baseStyle.tabTitleContainer}>
              <Text type={TEXT_TYPES.SIDEBAR_NUMBERS}>{tabsgroup.title}</Text>
            </Box>
            <Box sx={baseStyle.activeTab}>
              <Text type={TEXT_TYPES.H3}>{selectedTabCaption}</Text>
            </Box>
            <Flex sx={baseStyle.tabsContainer}>
              {tabsgroup.tabs.map((item: any, index: number) => (
                <Box
                  sx={{
                    ...baseStyle.tabTitle,
                    color: selectedTab === index ? '#000' : 'white',
                    background: selectedTab === index ? '#FFF' : '#8086F2',
                    padding:
                      selectedTab === index ? '25px 0 15px 0' : '15px 0 15px 0',
                    display:
                      selectedTab === index
                        ? ['none', 'none', 'block']
                        : 'block',
                  }}
                  onClick={() => {
                    setSelectedTab(index);
                    setSelectedTabCaption(item.tab.tabNameTitle);
                  }}
                >
                  <Text type={TEXT_TYPES.H4}>{item.tab.tabNameTitle}</Text>
                </Box>
              ))}
            </Flex>
            <Box sx={baseStyle.tabsContentContainer}>
              {tabsgroup.tabs.map((item: any, index: number) => (
                <Box
                  sx={{
                    ...baseStyle.descriptionContainer,
                    opacity: selectedTab === index ? '1' : '0',
                    position:
                      selectedTab === index ? ['relative'] : ['absolute'],
                  }}
                >
                  <BackgroundImage
                    fluid={
                      item.tab.tabContent.backgroundImage?.localFile
                        ?.childImageSharp?.fluid
                    }
                    sx={baseStyle.tabsContentImageContainer}
                  >
                    {descriptionContent(item)}
                  </BackgroundImage>
                </Box>
              ))}
              <BackgroundImage
                fluid={
                  tabsgroup.tabs[selectedTab].tab.tabContent
                    .mobileBackgroundImage?.localFile?.childImageSharp?.fluid
                }
                sx={baseStyle.tabsContentMobileImageContainer}
              >
                {descriptionContent(tabsgroup.tabs[selectedTab])}
              </BackgroundImage>
            </Box>
          </Flex>
        </BackgroundImage>
      </Box>
    );
  },
);

export default TabsContent;
